import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { PROMOTION_CAMPAIGN_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const deletePromotionCampaignAdvertisementAction = createAsyncThunk(
    'price/deletePromotionCampaignAdvertisementAction',
    async (promotionCampaignId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.delete(`${ PROMOTION_CAMPAIGN_PATH }/${ promotionCampaignId }/advertisement`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const deletePromotionCampaignAdvertisementSlice = createSlice({
    name: 'deletePromotionCampaignAdvertisementsSlice',
    initialState: DEFAULT_STATE,
    extraReducers: builder => {
        builder.addCase(deletePromotionCampaignAdvertisementAction.pending, () => STATE__API__STARTED);
        builder.addCase(deletePromotionCampaignAdvertisementAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(deletePromotionCampaignAdvertisementAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const deletePromotionCampaignAdvertisementState = (state) => state.price.deletePromotionCampaignAdvertisement;
export default deletePromotionCampaignAdvertisementSlice.reducer;